// extracted by mini-css-extract-plugin
module.exports = {"homeList":"styles-module--home-list--3Kmqo","articleWrapper":"styles-module--article-wrapper--InArF"};